export const BOOKING_URL =
  "https://apac.dentalhub.online/soe/new/Dr%20Peter%20G%20Stejskal?pid=AUSTE01";
export const PHONE_DISPLAY = "(02) 6295 9460";
export const PHONE_TEL = "tel:+61262959460";
export const EMAIL = "reception@glebeparkdental.com.au";
export const ADDRESS_LINE1 = "188/15 Coranderrk Street";
export const ADDRESS_LINE2 = "Canberra City ACT 2601";
export const PRINCIPAL = "Dr Avantica Gupta";
export const SITE_URL = "https://glebeparkdental.com.au";
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/search/?api=1&query=Glebe+Park+Dental+15+Coranderrk+Street+Canberra+ACT+2601";

export const MAPS_EMBED =
  "https://www.google.com/maps?q=15%20Coranderrk%20Street%20Canberra%20ACT%202601&output=embed";

// Feature flags. testimonials kept OFF for AHPRA advertising compliance
// (National Law s133 restricts testimonials in health advertising).
export const FEATURES = { testimonials: false };

export const NAV_LINKS = [
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Offers", to: "/offers" },
  { label: "Smile Gallery", id: "gallery" },
  { label: "Journal", to: "/blog" },
  { label: "Contact", to: "/contact" },
];


export const EMERGENCY_TEXT = "Toothache? Ring us first thing — same-day slots where possible.";

export const GETTING_HERE = [
  {
    k: "Walking",
    v: "We're on Coranderrk Street, right next to Glebe Park — about five minutes on foot from the Canberra Centre and the City bus interchange. Look for the green logo on the glass.",
  },
  {
    k: "Parking",
    v: "Ticketed street parking along Coranderrk Street and Glebe Park, plus the Canberra Centre car park a couple of minutes' walk away. Mornings are easier than lunchtimes.",
  },
  {
    k: "Public transport",
    v: "Most city bus routes stop at the interchange on Alinga Street / East Row. The light rail terminus at Alinga Street is roughly a ten-minute walk.",
  },
  {
    k: "Access",
    v: "Street-level entry straight off the footpath, no stairs. If you need a hand with access or have a pram or wheelchair, just let reception know when you book.",
  },
];

export const BLOG_SERVICE_MAP = {
  "professional-teeth-whitening-canberra": "teeth-whitening",
  "how-long-do-dental-implants-last": "dental-implants",
  "childs-first-dental-visit-guide": "childrens-dentistry",
  "wisdom-teeth-when-to-remove": "wisdom-teeth-removal",
};

export const LUNCH_NUDGE = "Most check-ups are under an hour — easy to fit into a lunch break from Civic.";

export const HOURS = [
  { day: "Monday", time: "9:00am — 5:30pm" },
  { day: "Tuesday", time: "9:00am — 5:30pm" },
  { day: "Wednesday", time: "9:00am — 5:30pm" },
  { day: "Thursday", time: "9:00am — 5:30pm" },
  { day: "Friday", time: "9:00am — 5:30pm" },
  { day: "Saturday", time: "9:00am — 5:30pm" },
  { day: "Sunday", time: "Closed" },
];

export const IMAGES = {
  hero: "/photos/treatment-room.jpg",
  interior: "/photos/treatment-room.jpg",
  reception: "/photos/reception.jpg",
  hallway: "/photos/hallway.jpg",
  shopfront: "/photos/shopfront.jpg",
  street: "/photos/street.jpg",
  doctor:
    "https://images.unsplash.com/photo-1667133295352-ef4c83620e8e?crop=entropy&cs=srgb&fm=jpg&q=85",
  whitening: "/gallery/whitening.jpg",
  transform: "/gallery/makeover.jpg",
  children: "/gallery/aligners.jpg",
  implants:
    "https://images.unsplash.com/photo-1588776814546-daab30f310ce?crop=entropy&cs=srgb&fm=jpg&q=85",
  hygiene:
    "https://images.pexels.com/photos/8413334/pexels-photo-8413334.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    slug: "check-ups-and-cleans",
    name: "Check-ups & Cleans",
    tag: "Preventive",
    blurb:
      "The six-monthly one. A proper look around, a good clean, and an honest chat about anything we spot.",
    detail:
      "Nothing fancy here — just a thorough check-up done properly. We'll look at your teeth, gums and the soft tissue in your mouth, only take X-rays if there's a genuine reason to, and give everything a decent clean and polish. Then we'll show you what we found (you can see it on the screen too) and talk through what needs doing, what can wait, and what to keep an eye on. Most people are in and out in under an hour.",
    duration: "45–60 min",
    image: "/services/check-ups-and-cleans.jpg",
  },
  {
    slug: "same-day-crowns",
    name: "Same-Day Crowns",
    tag: "Restorative",
    blurb:
      "Scan, design, mill and fit — one appointment. No gooey moulds, no temporary, no coming back in a fortnight.",
    detail:
      "The old way of doing crowns meant two visits, a temporary that always seemed to pop off, and a mouthful of impression putty. Ours are different. We scan your tooth digitally, design the crown while you're in the chair, mill it from a block of ceramic on site, and fit it the same day. You walk in with a broken tooth and out with a permanent one that matches your others. Bring a podcast.",
    duration: "One visit, about 2 hours",
    image: "/services/same-day-crowns.jpg",
  },
  {
    slug: "dental-implants",
    name: "Dental Implants",
    tag: "Restorative",
    blurb:
      "The closest thing to getting your own tooth back. Planned carefully, placed gently, built to last.",
    detail:
      "Missing a tooth? An implant replaces the whole thing — a titanium root in the bone, with a ceramic crown on top — so you can bite into an apple again without thinking about it. It also stops the bone shrinkage that happens when a gap is left alone. We plan every implant off a 3D scan before anything happens, and we'll walk you through the stages, the timeline and the cost so there are no surprises along the way.",
    duration: "Staged over a few months",
    image: "/services/dental-implants.jpg",
  },
  {
    slug: "smile-makeovers",
    name: "Smile Makeovers",
    tag: "Cosmetic",
    blurb:
      "Veneers, whitening, a bit of reshaping — whatever mix gets you a smile that still looks like you.",
    detail:
      "A smile makeover isn't one procedure, it's a plan. We start with what bugs you about your smile (and what you like — that matters too), then work out the simplest combination of veneers, whitening, bonding or alignment to get there. The aim is a smile that looks natural in photos and feels like yours, not a row of piano keys. We'll show you a preview before you commit to anything.",
    duration: "Usually 2–4 visits",
    image: "/services/smile-makeovers.jpg",
  },
  {
    slug: "teeth-whitening",
    name: "Teeth Whitening",
    tag: "Cosmetic",
    blurb:
      "Proper dentist-strength whitening that actually works — and won't wreck your enamel like the chemist stuff can.",
    detail:
      "There's a big difference between what you can buy at the chemist and what we can use in the practice. Our gels are prescription strength, applied with your gums protected, so you get real results without the zingy sensitivity. Go in-chair for a big change in one visit, or take custom trays home and brighten up gradually over a week or two. We'll check your teeth first — whitening over a cavity is a bad time for everyone.",
    duration: "60–90 min in-chair",
    image: "/services/teeth-whitening.jpg",
  },
  {
    slug: "clear-aligners",
    name: "Clear Aligners (Invisalign)",
    tag: "Orthodontic",
    blurb:
      "Straighten your teeth with near-invisible aligners you take out to eat and brush. Free consult to see if you're a candidate.",
    detail:
      "Clear aligners are a series of thin, custom-made plastic trays that gradually move your teeth — no brackets, no wires, and most people won't notice you're wearing them. You swap to a new set every week or two, take them out to eat and brush, and check in with us every six to eight weeks. We scan your teeth digitally and show you a preview of your finished smile before you commit. Your first consult is free, so there's no cost to finding out whether aligners will work for you.",
    duration: "Typically 6–18 months",
    image: "/services/clear-aligners.jpg",
  },
  {
    slug: "root-canal-therapy",
    name: "Root Canal Treatment",
    tag: "Endodontic",
    blurb:
      "Not the horror story you've heard. It stops the pain, saves the tooth, and most people are surprised how uneventful it is.",
    detail:
      "Root canals have a terrible reputation they no longer deserve. The toothache that brings you in is the painful part — the treatment is what makes it stop. We numb the area thoroughly, take our time, and clean out the infected nerve so you can keep your natural tooth rather than lose it. Most patients tell us afterwards it felt like a long filling. If you've got a throbbing tooth, ring us — the sooner we see it, the simpler it is.",
    duration: "1–2 visits",
    image: "/services/root-canal-therapy.jpg",
  },
  {
    slug: "wisdom-teeth-removal",
    name: "Wisdom Teeth & Extractions",
    tag: "Surgical",
    blurb:
      "Wisdom tooth assessments and removals, done gently here in the chair rather than a hospital.",
    detail:
      "Most wisdom teeth — and the occasional tooth that's past saving — can be taken out right here with local anaesthetic, no hospital or general needed. We'll assess yours with an X-ray, tell you straight whether it needs to come out or can just be watched, and if it does, talk you through exactly what to expect. You'll leave with clear aftercare instructions and our number in case you've got questions over the weekend.",
    duration: "Depends on the tooth",
    image: "/services/wisdom-teeth-removal.jpg",
  },
  {
    slug: "childrens-dentistry",
    name: "Kids' Dentistry",
    tag: "Family",
    blurb:
      "Relaxed first visits, zero pressure, plenty of high-fives. We want your kids to think the dentist is a bit of fun.",
    detail:
      "A child's first few dental visits set the tone for life, so we keep them short, light and pressure-free. They get a ride in the chair, we count their teeth together, they might get a go with the little mirror, and that's often it. We'll chat with you about brushing, snacks and fluoride without any judgement. We're also registered for the Child Dental Benefits Schedule — ask at reception and we'll check if your family's eligible.",
    duration: "30–45 min",
    image: "/services/childrens-dentistry.jpg",
  },
  {
    slug: "conscious-sedation",
    name: "Sedation for Anxious Patients",
    tag: "Comfort",
    blurb:
      "Dread the dentist? We offer happy gas and oral sedation so you can get treatment done calm, comfortable and without the white knuckles.",
    detail:
      "Plenty of people put off the dentist for years because of nerves, a bad past experience or a strong gag reflex. Conscious sedation takes the edge off. Nitrous oxide (happy gas) is breathed through a small nose mask — you feel relaxed and a bit floaty within minutes, and it wears off almost as soon as we turn it off, so you can drive home. Oral sedation is a tablet taken before your appointment for deeper relaxation; you'll need someone to drive you. Either way you stay awake, can respond to us, and most people remember very little of the appointment. Just tell reception when you book and we'll plan it in.",
    duration: "Added to any appointment",
    image: "/services/conscious-sedation.jpg",
  },
];

export const SEDATION_NOTE =
  "Nervous about the dentist? We offer conscious sedation — happy gas or an oral tablet — for any appointment. Just mention it when you book.";

export const TEAM = [
  {
    slug: "dr-avantica-gupta",
    name: "Dr Avantica Gupta",
    role: "Principal Dentist",
    title: "Principal Dentist",
    summary: "A warm, patient-centred dentist who believes in clear communication, thoughtful treatment planning and making sure you feel comfortable, informed and confident at every visit.",
    photo: "/dr-gupta.jpg",
    paragraphs: [
      "Dr Gupta trained at UP Dental College and Research Centre and holds Australian Dental Council certification. Before taking over Glebe Park Dental she spent her time practising general dentistry here in Canberra, looking after patients from just about every background you can think of — which is exactly the way she likes it.",
      "Her thing is prevention and the long game: sort the small stuff early, explain everything properly, and only do what actually needs doing. She's the dentist who'd rather show you the X-ray and talk it through than hand you a treatment plan and a pen.",
    ],
    interests: [
      "Clear aligners & orthodontics",
      "Veneers & cosmetic work",
      "Root canal treatment",
      "Gum health",
      "Wisdom teeth removal",
      "Implant restorations",
      "Kids' preventive orthodontics",
      "Conscious sedation",
    ],
    facts: [
      { k: "Languages", v: "English and Hindi" },
      { k: "Volunteering", v: "Children's dental camps in India" },
      { k: "Weekends", v: "Bushwalking around the ACT" },
      { k: "Off duty", v: "Dancing and sketching" },
    ],
    quote: "Floss daily and actually wear your retainer. That's it, that's the secret.",
  },
  {
    slug: "dr-peter-stejskal",
    name: "Dr Peter G. Stejskal",
    role: "Dentist",
    title: "Dentist",
    summary: "Peter opened Glebe Park Dental in 1989 and has looked after Canberra smiles from this address ever since — thirty-five-plus years of steady, unhurried dentistry.",
    photo: null,
    paragraphs: [
      "Peter opened Glebe Park Dental in 1989 and has looked after Canberra smiles from this address ever since — for a lot of patients, he's the only dentist they've ever had, and he continues to see them here today.",
      "Thirty-five-plus years in one chair adds up to a lot of experience across general, restorative and surgical dentistry — crowns, implants, root canals, extractions — and a very steady pair of hands.",
    ],
    interests: ["Restorative dentistry", "Same-day crowns", "Dental implants", "Minor oral surgery", "Root canal treatment"],
    facts: [
      { k: "At Glebe Park since", v: "1989 — the beginning" },
      { k: "Works alongside", v: "Dr Avantica Gupta" },
    ],
    quote: "Good dentistry is mostly listening, then taking your time.",
  },
];

export const OFFERS = [
  {
    id: "new-patient",
    kicker: "New patients",
    title: "New Patient Check-up — $250",
    text: "A thorough first visit: full examination, gum check, oral cancer screen and the check-up X-rays we need to see between your teeth. Then an honest chat about what (if anything) needs doing.",
    fine: "New patients only. Includes clinical examination and standard check-up X-rays. A full-mouth X-ray (OPG), 3D scan or other diagnostic imaging may be charged separately if clinically needed.",
    cta: "Book your first visit",
    link: "/services/check-ups-and-cleans",
  },
  {
    id: "implant-consult",
    kicker: "Complimentary consultation",
    title: "Free Implant Consult",
    text: "Missing a tooth or facing an extraction? Sit down with us, talk through whether an implant is right for you, and leave with a clear picture of the stages, timeline and cost — no obligation.",
    fine: "Free for new patients. Covers the clinical consultation only; any X-rays, scans or diagnostic imaging may be charged separately.",
    cta: "Book a free implant consult",
    link: "/services/dental-implants",
  },
  {
    id: "aligner-consult",
    kicker: "Complimentary consultation",
    title: "Free Clear Aligner (Invisalign) Consult",
    text: "Wondering whether aligners could straighten your teeth? Come in for a free assessment, find out if you're a candidate and see how long it might take — before you spend a cent.",
    fine: "Free for new patients. Covers the clinical consultation only; any X-rays, scans or diagnostic imaging may be charged separately.",
    cta: "Book a free aligner consult",
    link: "/services/clear-aligners",
  },
];

export const OFFER = {
  headline: "New patient check-up incl. X-rays — $250",
  sub: "Plus free implant & clear aligner consults",
  fine: OFFERS[0].fine,
  href: BOOKING_URL,
};

export const REVIEWS = [
  {
    name: "Margaret H.",
    suburb: "Kingston",
    treatment: "Smile Makeover",
    rating: 5,
    text: "I'd been hiding my teeth in photos for about twenty years. Dr Gupta didn't try to sell me the works — she suggested a couple of veneers and some whitening, showed me a mock-up first, and the result is exactly what I wanted. I smile in photos now. My daughter noticed before I told her.",
  },
  {
    name: "David R.",
    suburb: "Braddon",
    treatment: "Dental Implant",
    rating: 5,
    text: "Put off replacing a back molar for ages because I assumed it'd be a nightmare. It wasn't. Everything was explained upfront including the cost, the actual procedure was a non-event, and now I genuinely forget which tooth it is.",
  },
  {
    name: "Priya S.",
    suburb: "Turner",
    treatment: "Check-up & Clean",
    rating: 5,
    text: "Finally a dentist who doesn't make you feel bad about how long it's been. Really thorough clean, they showed me the photos of my teeth on the screen and actually explained things. Booked online in about a minute and they ran on time, which I've never had at a dentist.",
  },
  {
    name: "Tom W.",
    suburb: "Ainslie",
    treatment: "Same-Day Crown",
    rating: 5,
    text: "Cracked a tooth on a Sunday roast, rang Monday morning, had a permanent ceramic crown by Monday afternoon. One visit. I was back at work in Civic before 3. Honestly didn't know that was even possible.",
  },
  {
    name: "Elena K.",
    suburb: "Reid",
    treatment: "Kids' Dentistry",
    rating: 5,
    text: "My five-year-old was terrified after a bad experience elsewhere. The team here just let her sit in the chair and press the buttons for the first visit. Now she asks when she's going back. That's all you need to know really.",
  },
  {
    name: "James L.",
    suburb: "O'Connor",
    treatment: "Teeth Whitening",
    rating: 5,
    text: "Went in wanting veneers. Dr Gupta talked me out of it and said whitening would get me most of the way for a fraction of the cost. She was right. Three shades whiter, no sensitivity, and I appreciated being told the cheaper option first.",
  },
];

export const FAQS = [
  {
    q: "Do I need a referral?",
    a: "Nope. Just book online or give us a ring. If you're coming from another dentist and want your records transferred, let us know and we'll sort it out with them — you don't have to do anything.",
  },
  {
    q: "Where do I park?",
    a: "We're on Coranderrk Street, right next to Glebe Park. There's ticketed street parking along Coranderrk and the Canberra Centre car park is a couple of minutes' walk. If you're coming from work in Civic, honestly, walking is quickest.",
  },
  {
    q: "Do you see kids?",
    a: "We do, and we like it. First visits are deliberately low-key — no pressure to open wide or be brave. We're also set up for the Child Dental Benefits Schedule, so ask reception and we'll check whether your kids are eligible for bulk-billed care.",
  },
  {
    q: "I've got a toothache. Can you fit me in today?",
    a: "Call us first thing on (02) 6295 9460. We keep some room in the day for people in pain and we'll do our best to see you the same day. If you ring after hours, leave a message and we'll get back to you as soon as we open.",
  },
  {
    q: "Which health funds do you take?",
    a: "All the major Australian funds. We've got HICAPS in the practice, so we swipe your card, the claim goes through on the spot and you just pay the gap. Bring your card or the app and we'll handle the rest.",
  },
  {
    q: "I'm really anxious about the dentist. Do you offer sedation?",
    a: "Yes. We offer conscious sedation for nervous patients — nitrous oxide (happy gas) breathed through a little nose mask, or an oral sedative tablet taken before your appointment for deeper relaxation. You stay awake and in control, but calm. It can be added to almost any appointment, from a clean to wisdom teeth. Just mention it when you book so we can plan it in.",
  },
  {
    q: "I haven't been to a dentist in years. Will I get a lecture?",
    a: "No. Genuinely. Everyone's got a reason — money, time, a bad experience, life. We'd much rather you come in now than in another five years, so we'll just start where you're at and go from there.",
  },
];
